<template>
	<div class="c-onboarding">
		<transition name="fade">
			<div
				v-if="counter > 0"
				:class="[
					'c-onboarding__cover',
					{
						'step-4': counter > 7,
					},
				]"
			></div>
		</transition>
		<!-- <div
			:class="['page page-1', { active: counter === 1 }]"
			v-if="counter === 1"
		>
			<div class="page__inner">
				<h1>
					<span v-for="l in strings.stage1.title" class="letter">{{ l }}</span>
				</h1>
				<h3 class="text">
					Your browser has a superpower now.<br />
					Let's get you familiar with it
				</h3>
				<a class="sexy-link button" @click="next()"> Show me </a>
			</div>
		</div> -->

		<transition
			appear
			name="fade"
			tag="div"
			:enter="onEnter"
			:before-leave="onEnter"
			mode="out-in"
		>
			<!-- frame 1 -->
			<div class="frame" v-if="counter === 1" key="1">
				<div class="frame-1">
					<h1>
						<span v-for="l in stages['1'].title" class="letter">{{ l }}</span>
					</h1>
					<h3 class="text">
						Your browser has a superpower now.<br />
						Let's get you familiar with it
					</h3>
					<h1 class="alt">Press</h1>
					<span class="key-container">
						<span class="key">Alt</span>+<span class="key">W</span>
					</span>
				</div>
			</div>
			<!-- frame 1 END -->
			<!-- frame 2 -->
			<div class="frame" v-if="counter > 1 && counter < 8" key="2">
				<div class="frame-2">
					<transition name="fade" mode="out-in">
						<article v-if="counter === 2" key="p3">
							<h1>This is your Notepad</h1>
							<p>This is available on every browser tab now.</p>

							<h3>Try it out. Press Alt+W while browsing on:</h3>
							<div class="list-container">
								<a
									class="list-item"
									target="_blank"
									href="https://gmail.com"
									@click="onUrlClick"
								>
									<span> Gmail </span>
								</a>
								<a
									class="list-item"
									target="_blank"
									href="https://yahoo.com"
									@click="onUrlClick"
								>
									<span> Yahoo </span>
								</a>
								<a
									class="list-item"
									target="_blank"
									href="https://youtube.com"
									@click="onUrlClick"
								>
									<span> Youtube </span>
								</a>
								<a
									class="list-item"
									target="_blank"
									href="https://slack.com"
									@click="onUrlClick"
								>
									<span>Slack</span>
								</a>
							</div>
						</article>
						<article v-if="counter === 3" key="p4">
							<h1>
								That's all to it.<br />
								Pin the extension for easier access.
							</h1>
							<p>Remember, Alt+W will summon the notepad.</p>
						</article>
						<!-- <article v-if="counter === 4" key="p4">
							<h1>You just saved your first block.</h1>
							<p>We call each section of text a block.</p>
							<h1>Now, try saving another text from the browser.</h1>
						</article>
						<article v-if="counter === 5" key="p5">
							<h1>
								Sweet. Nice, now drag from the bottom of the Notepad to select
								these text blocks.
							</h1>
						</article>
						<article v-if="counter === 6" key="p6">
							<h1>
								Press <span class="key">G</span> to group these notes together.
							</h1>
						</article>
						<article v-if="counter === 7" key="p7">
							<h1>Perfect!<br />You just grouped your notes together.</h1>
							<p>
								Dragging/editing notes and grouping notes -<br />
								with these two actions, you can do virtually anything with the
								Notepad.
							</p>
							<div>
								<a class="sexy-link button" @click="counter++">Next</a>
							</div>
						</article> -->
					</transition>
					<div class="iframe" v-if="counter >= 2">
						<Window @updated="onUpdated" :testMode="true"></Window>
					</div>
					<div class="row">
						<!-- <div class="col-4 col-center">
							<transition name="fade" mode="out-in">
								<article v-if="counter === 2" key="p2">
									<h1>
										Press <span class="key">Alt</span>+<span class="key"
											>W</span
										>
									</h1>
									<p class="p-small">This will summon the Notepad</p>
								</article>
								<article v-if="counter === 3" key="p3">
									<h1>This is your Notepad.</h1>
									<p>
										You can drop almost anything in here from the current page.
									</p>
									<h3>
										Let's test this out.<br />
										Select some text inside the browser and drag it inside the
										Notepad.
									</h3>
								</article>
								<article v-if="counter === 4" key="p4">
									<h1>You just saved your first block.</h1>
									<p>We call each section of text a block.</p>
									<h1>Now, try saving another text from the browser.</h1>
								</article>
								<article v-if="counter === 5" key="p5">
									<h1>
										Sweet. Nice, now drag from the bottom of the Notepad to
										select these text blocks.
									</h1>
								</article>
								<article v-if="counter === 6" key="p6">
									<h1>
										Press <span class="key">G</span> to group these notes
										together.
									</h1>
								</article>
								<article v-if="counter === 7" key="p7">
									<h1>Perfect!<br />You just grouped your notes together.</h1>
									<p>
										Dragging/editing notes and grouping notes -<br />
										with these two actions, you can do virtually anything with
										the Notepad.
									</p>
									<div>
										<a class="sexy-link button" @click="counter++">Next</a>
									</div>
								</article>
							</transition>
						</div> -->
						<!-- <div class="col-8">
							<div class="chrome-window">
								<div class="chrome-window__bar">
									<span class="chrome-window__btn b-close"> </span>
									<span class="chrome-window__btn b-minimize"> </span>
									<span class="chrome-window__btn b-expand"> </span>
								</div>
								<div class="chrome-window__toolbar">
									<div class="chrome-window__omnibox">
										<transition name="fade-slide" tag="div" mode="out-in">
											<div v-if="counter < 4" key="p1">
												<img src="https://www.nytimes.com/favicon.ico" />
												<span> www.nytimes.com </span>
											</div>
											<div v-else key="p2">
												<img src="https://en.wikipedia.org/favicon.ico" />
												<span> www.wikipedia.org/wiki/toaster </span>
											</div>
										</transition>
									</div>
									<div class="chrome-window__toolbar__item">
										<img src="https://underlineme.com/favicon.ico" />
									</div>
									<div class="chrome-window__toolbar__item">
										<more-vertical-icon size="1.5x"></more-vertical-icon>
									</div>
								</div>
								<div class="chrome-window__body iframe">
									<Window
										@updated="onUpdated"
										:testMode="true"
										:testDashboardActive="dashboardActive"
									></Window>
									<transition name="fade-slide" tag="div" mode="out-in">
										<div
											class="chrome-window__body__inner"
											v-if="counter < 4"
											key="p1"
										>
											<h3>
												Stimulus Checks Substantially Reduced Hardship, Study
												Shows
											</h3>
											<p class="temporal">
												If you can see this - chances are you're interested
												learning more about how I built this. In that case, why
												not ask the developer himself at shash@underlineme.com
												;)
											</p>
											<p>
												Researchers found that sharp declines in food shortages,
												financial instability and anxiety coincided with the two
												most recent rounds of payments.
											</p>
											<p class="temporal">
												Oh and here's some lorem ipsum cuz I couldn't find
												anything else. Quisque volutpat condimentum velit. Class
												aptent taciti sociosqu ad litora torquent per conubia
												nostra, per inceptos himenaeos. Nam nec ante. Sed
												lacinia, urna non tincidunt mattis, tortor neque
												adipiscing diam, a cursus ipsum ante quis turpis. Nulla
												facilisi. Ut fringilla.
											</p>
										</div>
										<div class="chrome-window__body__inner" v-else key="p2">
											<h3>
												A toaster is an electric small appliance designed to
												expose various types of sliced bread to radiant heat,
												browning the bread so it becomes toast.
											</h3>
											<p>
												In pop-up or automatic toasters, a single vertical piece
												of bread is dropped into a slot on the top of the
												toaster. A lever on the side of the toaster is pressed
												down, lowering the bread into the toaster and activating
												the heating elements.
											</p>
											<p class="temporal">
												The completion of toasting may be determined by timer or
												by a thermal sensor, such as a bimetallic strip, located
												close to the toast.
											</p>
										</div>
									</transition>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
			<!-- frame 2 END -->
			<!-- frame 3 -->
			<div class="frame" v-if="counter > 6" key="3">
				<div class="frame-3">
					<h1>Notepad.exe for the web</h1>
					<ul>
						<li>Save bits of text while juggling Slack, Docs, Emails, etc.</li>
						<li>Use it to collect research from various sites.</li>
						<li>Create summaries of online lectures and presentations</li>
						<li>Or use it to jot down random thoughts.</li>
					</ul>
					<article>
						<h3>One last bit – pin the extension to the toolbar.</h3>
						<p>
							If you ever forget the shortcut, press this icon to summon your
							Sidebar.
						</p>
						<a class="sexy-link button" @click="onClose"> Close </a>
					</article>
				</div>
			</div>
			<!-- frame 3 END -->
		</transition>
	</div>
</template>

<script>
import hotkeys from 'hotkeys-js';
import anime from 'animejs';

import smoothReflow from 'vue-smooth-reflow';

import Window from '@/components/widget/window';

import {
	MoreVerticalIcon,
	XIcon,
	MoveIcon,
	CornerUpRightIcon,
	Minimize2Icon,
	CheckIcon,
	ChevronRightIcon,
} from 'vue-feather-icons';

export default {
	mixins: [smoothReflow],

	components: {
		MoreVerticalIcon,
		XIcon,
		MoveIcon,
		CornerUpRightIcon,
		Minimize2Icon,
		CheckIcon,
		ChevronRightIcon,
		Window,
	},

	data: function () {
		return {
			marks: 0,
			toggledWidget: false,
			stage1: false,
			stage2: false,
			stage3: false,
			stage4: false,
			stage5: false,
			counter: 0,
			dashboardActive: false,
		};
	},

	computed: {
		user: function () {
			return this.$store.getters['user/user'];
		},
		stages: function () {
			return {
				1: {
					title: `Hello ${this.user.name}`,
				},
			};
		},
	},

	watch: {
		counter: function () {
			if (this.counter === 1) {
				setTimeout(() => {
					this.frame1();
				}, 500);
			}
			if (this.counter === 2) {
				this.frame2();
			}
			if (this.counter === 3) {
				this.frame2subframe1();
			}
			if (this.counter === 8) {
				setTimeout(() => {
					this.frame3();
				}, 500);
			}
		},
	},

	methods: {
		async onEnter() {},
		async frame1() {
			let timeline = anime.timeline({
				easing: 'easeOutExpo',
				duration: 300,
				delay: 400,
				autoplay: false,
			});

			timeline.add({
				targets: '.frame-1 h1 span',
				scale: [0.1, 1],
				opacity: [0, 1],
				translateZ: 0,
				delay: (el, i) => 45 * (i + 1),
			});

			timeline.add({
				targets: '.frame-1 h3',
				opacity: [0, 1],
				duration: 400,
				delay: 200,
			});

			timeline.add({
				targets: '.frame-1 .sexy-link',
				opacity: [0, 1],
				duration: 300,
				delay: 200,
			});

			timeline.add({
				targets: '.frame-1 h1.alt',
				opacity: [0, 1],
				duration: 300,
				delay: 1000,
			});

			timeline.add({
				targets: '.frame-1 .key-container',
				opacity: [0, 1],
				duration: 300,
				delay: 200,
			});
			timeline.play();
		},
		async frame2() {
			console.log('RUNNING FRAME 2');
			let timeline = anime.timeline({
				easing: 'easeOutExpo',
				duration: 500,
			});

			timeline.add({
				targets: '.frame-2 h1',
				opacity: [0, 1],
				duration: 500,
				easing: 'linear',
				delay: 2000,
			});
			timeline.play();
		},
		async frame3() {
			let timeline = anime.timeline({
				easing: 'easeOutExpo',
				duration: 500,
				delay: 1500,
				autoplay: false,
			});

			timeline.add({
				targets: '.frame-3 h1',
				opacity: [0, 1],
				duration: 750,
				delay: 250,
			});

			timeline.add({
				targets: '.frame-3 li',
				translateY: [-4, 0],
				opacity: [0, 1],
				translateZ: 0,
				delay: (el, i) => 450 * (i + 1),
			});

			timeline.add({
				targets: '.frame-3 article',
				opacity: [0, 1],
				duration: 750,
				delay: 1500,
			});
			timeline.play();
		},
		async frame2subframe1() {
			// Use this source for creating artificial blocks
			// https://www.nytimes.com/2021/06/02/us/politics/stimulus-checks-economic-hardship.html
		},
		start: function () {
			this.counter = 1;
		},
		end: function () {
			this.counter = 0;
			setTimeout(() => {
				this.$emit('end');
			}, 500);
		},
		async setupHotkeys() {
			hotkeys('alt+w', () => {
				console.log(this.counter);
				if (this.counter < 3) {
					setTimeout(() => {
						this.counter += 1;
						this.dashboardActive = !this.dashboardActive;
					}, 400);
				}
			});
			hotkeys.setScope('widget');
		},
		async removeHotkeys() {
			hotkeys.deleteScope('widget');
		},
		onUrlClick: function () {
			this.counter += 1;
		},
		onUpdated: function () {
			this.counter += 1;
			// if (this.counter < 4) {
			// 	this.counter += 1;
			// }
		},
		onClose: function () {
			window.close();
		},
	},
	async mounted() {
		//this.$smoothReflow();
		this.start();
		this.setupHotkeys();
		console.log('adding onboarding blocks');
		await this.$store.dispatch('block/insertOnboardingBlocks', null, {
			root: true,
		});
	},
	beforeDestroy: function () {
		console.log('NOT listening');
		this.removeHotkeys();
	},
};
</script>

<style lang="scss">
.c-onboarding {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	z-index: var(--z-3);

	color: #fff;

	@include scrollBars();

	.key-container {
		font-size: var(--font-size-lg);
	}
	.key {
		//background-color: rgba(255, 255, 255, 0.1);
		display: inline-flex;
		justify-content: start;
		align-items: flex-end;
		width: 100px;
		height: 60px;
		margin: 0 var(--margin-lg);
		padding: var(--margin-lg);
		border-radius: var(--border-radius);
		color: rgba(255, 255, 255, 0.9);
		font-size: var(--font-size);
		//border: rgba(255, 255, 255, 0.25) solid 2px;
		box-shadow: 0 0px 0 2px rgba(255, 255, 255, 0.25);
	}

	.frame {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.frame-1 {
		text-align: center;

		h1 span,
		h3,
		.sexy-link,
		.key-container,
		.alt {
			opacity: 0;
		}
	}

	.frame-2 {
		text-align: center;

		.iframe {
			position: relative;
			min-width: 440px;
			height: 584px;
			max-height: 584px;
			overflow: hidden;
			margin: var(--spacer) auto;
		}

		.list-container {
			.list-item {
				display: inline-flex;
				border-radius: 20px;
				margin: 0 var(--margin-lg);
				padding: var(--margin) var(--spacer-sm);
				border: var(--p3) solid 2px;
				align-items: center;

				img {
					width: 20px;
					height: 20px;
					margin-right: var(--margin-lg);
				}
			}
		}

		.key-container {
			font-size: var(--font-size-lg);
		}

		h1 {
			margin-bottom: var(--spacer-sm);
		}
		article {
			user-select: none;
		}
		.key {
			//background-color: rgba(255, 255, 255, 0.1);
			display: inline-flex;
			justify-content: start;
			align-items: flex-end;
			width: 100px;
			height: 60px;
			margin: 0 var(--margin-lg);
			padding: var(--margin-lg);
			border-radius: var(--border-radius);
			color: rgba(255, 255, 255, 0.9);
			font-size: var(--font-size);
			//border: rgba(255, 255, 255, 0.25) solid 2px;
			box-shadow: 0 0px 0 2px rgba(255, 255, 255, 0.25);
		}
	}

	.frame-3 {
		color: #000;

		h1,
		li,
		article {
			opacity: 0;
		}

		ul {
			margin: var(--spacer) 0;
		}

		li {
			position: relative;
			font-size: var(--font-size);
			margin-bottom: var(--margin-lg);

			&:before {
				position: absolute;
				top: 14px;
				left: -16px;
				content: '';
				width: 10px;
				height: 2px;
				background-color: var(--p3);
			}
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 400ms;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.fade-slide-enter-active {
		transition: opacity 200ms linear,
			transform 500ms cubic-bezier(0.275, 0.535, 0.59, 1);
	}
	.fade-slide-leave-active {
		transition: opacity 200ms linear,
			transform 500ms cubic-bezier(0.645, 0.005, 0.645, 0.41);
	}
	.fade-slide-enter, .fade-slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
		transform: translateY(50px);
	}

	.expand-enter-active,
	.expand-leave-active {
		transition: max-height 400ms;
	}
	.expand-enter, .expand-leave-to /* .fade-leave-active below version 2.1.8 */ {
		max-height: 0;
	}

	.col-center {
		display: flex;
		align-items: center;
	}

	.chrome-window {
		position: relative;
		margin: 0 auto;
		margin-bottom: var(--spacer-sm);
		border-radius: 6px;
		border: var(--g2) solid 3px;
		//background-color: rgb(44, 43, 43);
		text-align: left;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
			Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

		&__btn {
			display: inline-block;
			margin-right: 10px;
			width: 10px;
			height: 10px;
			border-radius: 50%;

			&.b-close {
				background-color: rgb(190, 89, 89);
			}

			&.b-minimize {
				background-color: rgb(202, 202, 105);
			}

			&.b-expand {
				background-color: rgb(121, 187, 121);
			}
		}

		&__bar {
			display: flex;
			padding: 10px;
			border-bottom: var(--g2) solid 3px;
		}

		&__toolbar {
			display: flex;
			padding: 10px;
			border-bottom: var(--g2) solid 3px;

			&__item {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: var(--margin);
				background-color: var(--g3);
				border-radius: var(--border-radius);
				margin-left: var(--margin-lg);

				svg {
					opacity: 0.5;
				}

				img {
					opacity: 0.75;
					margin: 0 var(--margin);
					width: calc(var(--spacer) / 2);
					height: calc(var(--spacer) / 2);
				}
			}
		}

		&__omnibox {
			display: block;
			width: 100%;
			background-color: var(--g3);
			border-radius: var(--border-radius);
			border: var(--g2) solid 1px;
			user-select: none;
			overflow: hidden;

			> div {
				height: 100%;
				display: flex;
				align-items: center;
				padding-left: var(--margin);
			}

			img {
				margin-right: var(--margin);
				width: 20px;
				height: 20px;
			}

			span {
				opacity: 0.5;
			}
		}

		&__body {
			position: relative;
			min-height: 600px;
			padding: 10px;
			line-height: 1.4;

			.c-window.active ~ .chrome-window__body__inner {
				margin-left: 340px;
			}
		}

		.temporal {
			display: inline;
			line-height: 2;
			box-decoration-break: slice;
			color: transparent;
			background-color: var(--g2);
			user-select: none;
		}
	}

	&__cover {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		overflow: hidden;

		&:before {
			content: '';
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			background-color: #fff;

			transition: opacity 2000ms ease-out;
		}

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			background: radial-gradient(
				circle farthest-side at right top,
				#9fbcbd 5%,
				#0f2d49 65%,
				#000
			);

			transition: opacity 2000ms ease-out;
		}

		&.step-3:after {
			opacity: 1;
		}

		&.step-4:before {
			opacity: 1;
		}
	}

	.sexy-link {
		margin: var(--margin-lg) 0;
		display: inline-block;
		font-weight: 600;
		font-size: var(--font-size);
		cursor: pointer;
		transition: all var(--transition-time) ease-out;
		user-select: none;

		&:active {
			transform: scale(0.95);
		}
	}

	h1 {
		font-weight: 300;
	}

	h2,
	h3,
	h4 {
		line-height: 1.4;
	}
}
</style>